const connectedAndGoodChain = (connected: boolean, chainID: number) => {

    return connected && (chainID === 25 || chainID === 338 || chainID ===  1337)

}

export default connectedAndGoodChain